module.exports = __webpack_public_path__ + "img/copa-prosa-golfistas.11bc7ad8.png";